import moment from 'moment';

export class DateTimeUtil {
  private static lang = 'en';

  public static setLanguage(lang: string): void {
    DateTimeUtil.lang = lang;
    moment.locale(this.lang);
  }

  public static getMinutesFromSeconds(seconds: number): number {
    return Math.floor(seconds / 60);
  }

  public static getRemainingSeconds(seconds: number): number {
    return seconds % 60;
  }

  public static formatDate(date: Date, format: string | undefined): string {
    return moment(date)
      .format(!!format ? format : 'MMM Do YYYY')
      .toString();
  }

  public static displayDate(date: Date, formats?: IDisplayDateFormats): string {
    if (formats) {
      formats.withinWeek = !!formats.withinWeek ? formats.withinWeek : 'dddd';
      formats.default = !!formats.default ? formats.default : 'MMM Do YYYY';
    } else {
      formats = {
        withinWeek: 'dddd',
        default: 'MMM Do YYYY'
      };
    }

    const given = moment(date);
    const today = moment(new Date());

    const yesterday = today.clone().subtract(1, 'days');
    const aWeekAgo = today.clone().subtract(1, 'weeks');

    if (given.isAfter(yesterday)) {
      return 'today';
    } else if (given.isSame(yesterday)) {
      return 'yesterday';
    } else if (given.isAfter(aWeekAgo)) {
      return this.formatDate(date, formats.withinWeek);
    } else {
      return this.formatDate(date, formats.default);
    }
  }

  public static addMinutesToDate(date: Date, minutes: number = 1): Date {
    const given = moment(date);
    return given.add(minutes, 'minute').toDate();
  }

  public static addHoursToDate(date: Date, hours: number = 1): Date {
    const given = moment(date);
    return given.add(hours, 'hour').toDate();
  }
}

export interface IDisplayDateFormats {
  withinWeek?: string;
  default?: string;
}
